export default "__VITE_ASSET__CDD0tpeM__"